define((require) => {
    "use strict";

    var _               = require("underscore"),
        $               = require("jquery"),
        Backbone        = require("backbone"),
        Window          = require("shared/services/Window"),
        Class           = require("shared/util/Class"),
        Preconditions   = require("shared/util/Preconditions");

    // Also used in Channels Admin Application - cannot include Browser module!
    function getTemplate(settings) {
        function tooltipCSS(settings) {
            return setMarginCSS(settings, tooltipOffset, {width: settings.width, height: settings.height});
        }

        function arrow(settings) {
            return $("<div></div>", {
                "class": "arrow",
                css: setMarginCSS(settings, arrowOffset.bind(null, settings.offset.align), {})
            });
        }

        function setMarginCSS(settings, fn, obj) {
            obj[getMargin(settings.offset.align)] = getsignFn(settings.offset.align)(fn.apply(null, getDists(settings)));

            return obj;
        }

        function getsignFn(align) {
            return function(n) {
                return isLoT(align) ? -n : n;
            };
        }

        function getMargin(align) {
            return isLoR(align) ? "margin-left" : "margin-top";
        }

        function isLoR(x) {
            return (x === "left" || x === "right");
        }

        function isLoT(x) {
            return (x === "left" || x === "top");
        }

        function tooltipOffset(dist, dist2) {
            return dist / 2 - dist2 / 2;
        }

        function arrowOffset(align, dist, dist2) {
            return -(tooltipOffset(dist, dist2)) - getsignFn(align)(11);
        }

        function getDists(settings) {
            if (isLoR(settings.offset.align)) {
                return [settings.offset.elementWidth, settings.width];
            }

            return [settings.offset.elementHeight, settings.height];
        }

        var html = "<div class='popover-content'></div>";

        if (settings.title !== false) {
            html = "<div class='popover-title'></div>" + html;
        }

        return $("<div></div>", {
            html: html,
            "class": "popover zmags-tooltip " + settings.background + " " + settings.classes,
            css: tooltipCSS(settings)
        }).prepend(arrow(settings));
    }

    function getContent(settings, type, element) {
        var content = settings[type];

        if (content) {
            if (content instanceof Backbone.View) {
                // Render on demand instead of on initialization
                var rendered = false;

                return function() {
                    if (rendered) {
                        return content.$el;
                    }

                    rendered = true;

                    return content.render().$el;
                };
            } else if (typeof content === "string") {
                // Selector, or just plain text?
                if (content.charAt(0) === ":") {
                    // Return a function, so it can be invoked each time the tooltip is to be shown, to ensure
                    // that the content is updated according to the current dom...
                    return function() {
                        var e = element.parent().find(content.substring(1)).clone();
                        e.css("display", "block");

                        return $("<div></div>").append(e).html();
                    };
                }
            }

            return content; // can be a function, dom element, or a string...
        }

        return _.escape(element.data(type));
    }

    function getTitle(settings, element) {
        return getContent(settings, "title", element);
    }

    function getData(settings, element) {
        return getContent(settings, "content", element);
    }

    // Applies "fn($(E))" for each element, say E, in "element" (dom element or $ selector) with a scope of $(E), and
    // returns an array of all such jQuery elements affected...
    function apply(element, fn) {
        Preconditions.checkArguments(element);

        var elementsArray;
        if (typeof element === "string") {
            elementsArray = $("body").find(element);
        } else if (_.isArray(element)) {
            elementsArray = element;
        } else {
            elementsArray = [element];
        }

        var appliedElements = [];
        _.each(elementsArray, (e) => {
            e = e.jquery ? e : $(e);
            fn.call(e, e); // e is scope, but also supplied as single argument, hence "call", and not "apply" used!
            appliedElements.push(e);
        });

        return appliedElements;
    }

    /**
     * Utility class to manage tooltips. <p>
     *
     * By default, tooltip content and optional title normally fetched as "data-content" and "data-title", respectively,
     * from the element(s) the tooltip is added to. <p>
     *
     * Example usage:
     *
     *  Tooltip.add(this.ui.test, { // or array of elements, or a jQuery selector for relevant element(s) under "body"
     *      trigger: "click",       // see defaults below
     *      placement: "right",
     *
     *      // You can set height and width manually. Height is required if you
     *      // define an offset with align: "top" or "bottom"
     *      height: 400,
     *
     *      // without offset: {}, the tooltips will be aligned in the center.
     *      // elementHeight and elementWidth should be the height and width of
     *      // the element that the tooltip is being applied to and is need
     *      offset: {
     *          align: "top",       // "bottom" | "left" | "right"
     *          elementHeight: 21,  // only needed if align = "top" or "bottom"
     *          elementWidth: 81    // only needed if align = "left" or "right"
     *      },
     *
     *      // Optional title/content for the pop-up, can also be specified as "data-title"/"data-content"
     *      // on the dom element. Can be a function, invoked with dom element scope for
     *      // the element the tooltip is attached to, a jQuery element for which the *outer* html is to be added,
     *      // but with "display:block", a string as-is, or a jQuery selector if a string starting with ":" (":" is
     *      // thus ignored), executed from the *parent* of the element the tooltip is attached to.
     *      title: "Tooltip title",
     *      content: function() { return "Tadaaa"; }
     *  });
     *
     * @author Gorm Casper / <a href="http://www.zmags.com">Zmags</a>
     * @author Gunni Rode  / <a href="http://www.zmags.com">Zmags</a>
     *
     * @class Tooltip
     */
    return Class.extend({}, {

        /**
         * Add a tooltip to the given element(s).
         *
         * @param {String|jQuery|jQuery[]} element The element(s) to add the tooltip to, or a selector to find element(s)
         *                                         to add the tooltip to.
         * @param {Object}                 config  The configuration object. For documentation on the config/settings,
         *                                         see http://getbootstrap.com/javascript/#popovers. Can be null/undefined.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #create
         * @see    #remove
         */
        add: function(element, config) {
            config = config || {};

            var settings = _.extend({
                html:           false,      // enables html tooltip content
                container:      "body",     // the tooltip DOM el gets appended to this
                trigger:        "hover",    // how the tooltip will be triggered; can be hover, click, focus, manual
                placement:      "bottom",   // where tooltip will be placed in relation to the element provided
                offset:         "",         // where tooltip arrow will be placed in relation to the element provided
                background:     "",         // "" (white) | "tooltip-danger" | "tooltip-warning" (add more when needed in components/tooltip.less),
                classes:        "",         // additional classes to add
                width:          "auto",     // tooltip width
                height:         "auto",     // tooltip height
                duration:       5000        // the duration that tooltip should auto hide, set to 0 or negative value will not hide automatically
            }, config);

            settings.template = getTemplate(settings);

            // "element" can be a string, an element, or an array of elements...
            return apply(element, function() {
                // Invariant: this = e = this jQuery element, not (necessarily) "element"

                var self = this,
                    timeoutHandler = null;

                // Update settings with title and content per element...
                settings.title = getTitle(settings, this);

                settings.content = getData(settings, this);

                // There is nothing called dropdown, so we have to emulate it
                // as best we can.
                if (settings.trigger === "dropdown") {
                    settings.trigger = "click";

                    var el = self.get(0),
                        subscription = Window.on("click", (event) => {
                            var popover = $(".popover.in")[0],
                                target = event.target;

                            if (popover && el !== target && popover !== target && !$.contains(popover, target)) {
                                self.popover("hide");
                            }
                        });

                    // Unsubscribe when the element is removed.
                    self.on("destroyed", subscription.off);
                }

                this.popover(settings);

                this.on("shown.bs.popover", () => {
                    if (timeoutHandler) {
                        clearTimeout(timeoutHandler);
                    }

                    if (settings.duration > 0) {
                        timeoutHandler = setTimeout(() => {
                            self.popover("hide");
                        }, settings.duration);
                    }
                });
            });
        },

        /**
         * (Re-)adds a tooltip to the given element(s) by first removing the tooltip, if any, then adds it again.
         *
         * @param {String|jQuery|jQuery[]} element The element(s) to (re-)add the tooltip to, or a selector to find
         *                                         element(s) to (re-)add the tooltip to.
         * @param {Object}                 config  The configuration object. For documentation on the config/settings,
         *                                         see http://getbootstrap.com/javascript/#popovers. Can be null/undefined.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #remove
         * @see    #add
         */
        create: function(element, config) {
            return this.add(this.remove(element), config);
        },

        /**
         * Shows the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element The element to show the already added tooltip for, or a selector to find
         *                                element(s) to show the tooltip for.
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #hide
         */
        show: function(element) {
            return apply(element, function() {
                this.popover("show");
            });
        },

        /**
         * Returns true if the tooltip is currently showing, false otherwise.
         *
         * @param {String|jQuery} element The element to test is shown or not, or a selector to find
         *                                element(s) to test if shown; if just one is shown, true will be
         *                                returned.
         * @return {Boolean} True if currently shown, false otherwise.
         * @see    #show
         */
        shown: function(element) {
            var shown = false;
            apply(element, function() {
                var data = this.data("bs.popover");
                shown = shown || (data && data.hoverState === "in");
            });

            return shown;
        },

        /**
         * Hides the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element The element to hide the already added tooltip for, or a selector to find
         *                                element(s) to hide the tooltip for.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #show
         */
        hide: function(element) {
            return apply(element, function() {
                this.popover("hide");
            });
        },

        /**
         * Removes the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery|Array} element The element to remove the already added tooltip for, or a selector to find
         *                                element(s) to remove the tooltip for.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        remove: function(element) {
            return apply(element, function() {
                this.popover("destroy");
            });
        },

        /**
         * Disable the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element to be disabled
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        disable: function(element) {
            return apply(element, function() {
                this.popover("disable");
            });
        },

        /**
         * Enable the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element to be enable
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        enable: function(element) {
            return apply(element, function() {
                this.popover("enable");
            });
        },

        /**
         * Returns the actual size tooltip dom element added to the supplied jQuery element.
         *
         * @param   {jQuery} element The jQuery element assumed to have a tooltip added to it.
         * @returns {{width:Number, height:Number}} A (width,height) pair for the actual tooltip dom element; never null.
         */
        size: function(element) {
            Preconditions.checkArguments(element);
            var e = element.find(".popover");

            return {width: e.outerWidth(), height: e.outerHeight()};
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/Tooltip.js